// eslint-disable-next-line
import {injectable} from "inversify";
import {TYPE, rootContainer} from '../container/root';
import {IApiResponse, IHttpService} from "../http-service";
import {IAddon, IAddonRefershedStatus} from "../../models/Addon";
import {makeAutoObservable} from "mobx";
import { IAddonChanges } from "../../pages/accounts/addons-section/stores/addons-store-list";

@injectable()
class AddonsService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    constructor() {
        makeAutoObservable(this);
    }

    async getAddons(): Promise<IAddon[]> {
        const res = await this.httpService.get<IApiResponse<IAddon[]>>(`/rms-api/addons`);
        return res.payload;
    }

    async generateBillingLink(addonsSummary: IAddonChanges[]): Promise<string> {
        const res = await this.httpService.post<IApiResponse<string>>(`/rms-api/addons/generate-billing-link`, addonsSummary);
        return res.payload;
    }

    async getRefreshedAddonsList(addonsList: IAddonChanges[]): Promise<IAddonRefershedStatus[]> {
        const res = await this.httpService.post<IApiResponse<IAddon[]>>(`/rms-api/addons/refresh-addons-list`, addonsList);
        return res.payload; 
    }

}

export default AddonsService;
